<main id="main">
    <!-- ======= About Us Section ======= -->
        <div class="mobile_version-backbutton">
        <a class="mobile-header" onclick="history.back()">
            <span> <img src="../../../assets/images/tournament/backBtn.svg" alt=""> </span>Teams </a>
    </div>
    <section id="services" class="services team-page-section" >
        <div class="container" > 
            <div class="row">
                <div class="col-md-12 size-img back-img">
                    <div class="effect-cover">
                        <h3 class="txt-advert animated fadeInUp">Teams</h3>
                    </div>
                </div>
                <div class="teamsList">
                        <ul>
                        <li *ngFor="let team of teamList">
                            <div class="teamMain-div">
                                <div class="logo">
                                        <img src="{{team.logoImage}}" alt="">
                                </div>
                                <div class="teamName">
                                    <h4>{{team.name}}</h4>
                                </div>
                                <div class="moreBtn"  (click)="onClickLogo(team.slug)">
                                    <button>KNOW MORE</button>
                                </div>
                            </div>
                        </li>
                        </ul>
                </div>                  
            </div>
        </div>
    </section>
    <!-- ======= End About Us Section ======= -->
</main><!-- End #main -->